import { render, staticRenderFns } from "./RoomTypes.vue?vue&type=template&id=442e6a2e&"
import script from "./RoomTypes.vue?vue&type=script&lang=js&"
export * from "./RoomTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports